import { useGetDisplayStylesParams } from 'root/hooks/useGetDisplayStylesParams';

export const useLabelLogic = () => {
  const { showItemLabelsName, showItemLabelsIcon } = useGetDisplayStylesParams();

  return { showItemLabelsName, showItemLabelsIcon };
};
